import { useState } from "react";

import { Export } from "../../../types/types";
import Button from "../Button/Button";
import ExportVector from "../../../assets/ExportVector";
import "./ExportButton.scss";

interface ExportButtonProps {
	text?: string;
	disabled?: boolean;
	fieldsSelected?: number;
	initiate(): Promise<Export | void>;
}

export default function ExportButton({ text = "Export", initiate, disabled }: ExportButtonProps) {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | undefined>();
	const [success, setSuccess] = useState<string | undefined>();

	const onExport = () => {
		setError(undefined);
		setSuccess(undefined);
		setLoading(true);
		initiate()
			.then(() => {
				setSuccess("Export started. Track progress in Team settings → Exports.");
			})
			.catch(() => {
				setError("Failed to start export. Please try again later or contact support.");
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<div className="export-button-container">
			<Button variant="contained" disabled={loading || disabled} onClick={() => onExport()}>
				<div className="group-card-button">
					<ExportVector />
					{text}
				</div>
			</Button>
			{error && <div className="export-error">{error}</div>}
			{success && <div className="export-success">{success}</div>}
		</div>
	);
}
